import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BlockStep, ContentBlock, Step } from '../../models';

@Component({
  selector: 'app-content-block-steps',
  templateUrl: './content-block-steps.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockStepsComponent implements OnInit {
  @Input() block!: ContentBlock;
  steps!: Step[];

  constructor() {}

  ngOnInit(): void {
    console.log('');

    if (this.block.steps) {
      this.steps = [
        ...this.block.steps?.map(a => {
          return { id: a.id, active: false };
        }),
      ];

      if (this.steps.length) {
        this.steps[0].active = true;
      }
    }
  }

  openStep(step: BlockStep) {
    // get old active step
    let oldStep: any = this.steps.find(s => s.active);

    // check if oldstep same as click step
    if (step.id === oldStep.id) {
      return;
    }

    // reset step
    oldStep.active = false;

    // get new active step
    let newStep: any = this.steps.find(s => s.id === step.id);
    // set new active step active
    newStep.active = true;

    setTimeout(() => {
      const elStep = document.querySelector(`[data-id="Step-${step.id}"]`);

      if (elStep) {
        const elementPosition = elStep.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 105;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
        // elStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 300);
  }
}
